import $ from "jquery";

const scResetPasswordForm = () => {
  const init = () => {
    handlerTogglePassword();
    handlerFormSubmit();
  };

  const el = {
    form: '#homey-reset-password-form',
    msg: '#homey_msg_reset_pass',
    btn: '#homey_reset_password_btn',
    triggerModal: '#trigger-login-modal',
  };

  const handlerTogglePassword = () => {
    $(document).on('click', '.toggle-password', function() {
      const $button = $(this);
      const $input = $button.siblings('.toggle-input-password');
      const isPassword = $input.attr('type') === 'password';

      $input.attr('type', isPassword ? 'text' : 'password');

      if (isPassword) {
        $button.html(`
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M19.2501 7.14491C18.7601 6.36491 18.2001 5.66491 17.6201 5.03491L13.8501 8.80491C13.9701 9.17491 14.0401 9.57491 14.0401 9.99491C14.0401 12.2349 12.2301 14.0349 10.0001 14.0349C9.5801 14.0349 9.1801 13.9649 8.8101 13.8449L5.3501 17.3049C6.8101 18.1249 8.3901 18.5549 10.0001 18.5549C11.7801 18.5549 13.5101 18.0349 15.0901 17.0649C16.6701 16.0849 18.0901 14.6549 19.2501 12.8349C20.2501 11.2749 20.2501 8.71491 19.2501 7.14491Z" fill="currentColor"/>
            <path d="M12.0199 7.97501L7.97989 12.015C7.46989 11.495 7.13989 10.775 7.13989 9.99501C7.13989 8.42501 8.41989 7.13501 9.99989 7.13501C10.7799 7.13501 11.4999 7.46501 12.0199 7.97501Z" fill="currentColor"/>
            <path opacity="0.4" d="M16.25 3.74505L12.86 7.13505C12.13 6.39505 11.12 5.95505 10 5.95505C7.76 5.95505 5.96 7.76505 5.96 9.99505C5.96 11.115 6.41 12.125 7.14 12.855L3.76 16.245H3.75C2.64 15.345 1.62 14.195 0.75 12.835C-0.25 11.265 -0.25 8.71505 0.75 7.14505C1.91 5.32505 3.33 3.89505 4.91 2.91505C6.49 1.95505 8.22 1.42505 10 1.42505C12.23 1.42505 14.39 2.24505 16.25 3.74505Z" fill="currentColor"/>
            <path d="M12.8601 9.99495C12.8601 11.565 11.5801 12.855 10.0001 12.855C9.94008 12.855 9.89008 12.855 9.83008 12.835L12.8401 9.82495C12.8601 9.88495 12.8601 9.93495 12.8601 9.99495Z" fill="currentColor"/>
            <path d="M19.7699 0.225C19.4699 -0.075 18.9799 -0.075 18.6799 0.225L0.229883 18.685C-0.0701172 18.985 -0.0701172 19.475 0.229883 19.775C0.379883 19.915 0.569883 19.995 0.769883 19.995C0.969883 19.995 1.15988 19.915 1.30988 19.765L19.7699 1.305C20.0799 1.005 20.0799 0.525 19.7699 0.225Z" fill="currentColor"/>
          </svg>
        `);
      } else {
        $button.html(`
          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M19.25 5.72C16.94 2.09 13.56 0 10 0C8.22 0 6.49 0.52 4.91 1.49C3.33 2.47 1.91 3.9 0.75 5.72C-0.25 7.29 -0.25 9.84 0.75 11.41C3.06 15.05 6.44 17.13 10 17.13C11.78 17.13 13.51 16.61 15.09 15.64C16.67 14.66 18.09 13.23 19.25 11.41C20.25 9.85 20.25 7.29 19.25 5.72ZM10 12.61C7.76 12.61 5.96 10.8 5.96 8.57C5.96 6.34 7.76 4.53 10 4.53C12.24 4.53 14.04 6.34 14.04 8.57C14.04 10.8 12.24 12.61 10 12.61Z" fill="currentColor"/>
            <path d="M9.9999 5.70996C8.4299 5.70996 7.1499 6.98996 7.1499 8.56996C7.1499 10.14 8.4299 11.42 9.9999 11.42C11.5699 11.42 12.8599 10.14 12.8599 8.56996C12.8599 6.99996 11.5699 5.70996 9.9999 5.70996Z" fill="currentColor"/>
          </svg>
        `);
      }
    });
  };

  const handlerFormSubmit = () => {
    $(document).on('submit', el.form, function(e) {
      e.preventDefault();

      const pass1 = $('#reset_pass').val();
      const pass2 = $('#reset_pass_confirm').val();

      if (!pass1) {
        $(el.msg).html('<p class="text-danger">Please enter a password.</p>').show();
        return;
      }

      if (!pass2) {
        $(el.msg).html('<p class="text-danger">Please confirm your password.</p>').show();
        return;
      }

      if (pass1 !== pass2) {
        $(el.msg).html('<p class="text-danger">Passwords do not match.</p>').show();
        return;
      }

      if (pass1.length < 8) {
        $(el.msg).html('<p class="text-danger">Password must be at least 8 characters.</p>').show();
        return;
      }

      const strongPassPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      if (!strongPassPattern.test(pass1)) {
        $(el.msg).html('<p class="text-danger">The password must contain uppercase, lowercase, number, and symbol (min 8 chars).</p>').show();
        return;
      }

      $(el.btn).prop('disabled', true).text('Resetting...');

      const formData = new FormData(this);
      formData.append('action', 'homey_ajax_reset_password');

      $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: function(response) {
          if (response.success) {
            $(el.msg).html('<p class="text-success">' + response.data + '</p>').show();
            $(el.form)[0].reset();
            setTimeout(function() {
              $(el.triggerModal).trigger('click');
            }, 500);
          } else {
            $(el.msg).html('<p class="text-danger">' + response.data + '</p>').show();
          }
        },
        error: function() {
          $(el.msg).html('<p class="text-danger">An error occurred. Please try again.</p>').show();
        },
        complete: function() {
          $(el.btn).prop('disabled', false).text('Reset Password');
        }
      });
    });
  };

  init();
};

try {
  scResetPasswordForm();
} catch (e) {
  console.error("Reset Password Form Error: ", e);
}

